import authenticate from '@/middleware/authenticate'
import apiDepartment from '@/api/administration/department'

export default [
  {
    path: '/departments',
    name: 'department',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/department/index.vue')
  },
  {
    path: '/departments/:id',
    name: 'department-edit',
    meta: { middleware: authenticate },
    component: () => import('@/pages/administration/department/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await apiDepartment.find(to.params.id)
      to.params.editData = response.data
      next()
    }
  }
]
